import { NgModule } from '@angular/core';
import { AosDirective } from './aos.directive';

@NgModule({
    imports: [AosDirective],
    providers: [AosDirective],
    exports: [AosDirective]
})
export class AosModule {}
